import { formatPlaylist, formatPlaylistBasic, Playlist, PlaylistBasic } from '@/util/formatters';
import { createNetworkApi, Response, toQuery } from '@/common/util/networkRequest';

import gameApi from './game';

import apiInstance from './instance';

export const PLAYLIST_LIMIT = 24;

const basicPlaylistQuery = {
  fields: {
    'node--playlist': [
      'drupal_internal__nid',
      'title',
      'created',
      'path',
      'field_thumbnail',
      'field_long_description',
      'field_playlist_description'
    ],
  },
  include: [
    'field_thumbnail'
  ]
};

const playlistQuery = {
  fields: {
    'node--playlist': [
      'drupal_internal__nid',
      'title',
      'created',
      'path',
      'field_thumbnail',
      'field_long_description',
      'field_playlist_description',
      'field_games'
    ],
  },
  include: [
    'field_thumbnail',
    'field_games',
    'field_games.field_thumbnail'
  ]
};

interface PlaylistApi {
  listAll: (limit?: number, offset?: number) => Promise<Response<PlaylistBasic[]>>;

  getById: (playlistId: string) => Promise<Response<Playlist>>;
}

export default createNetworkApi<PlaylistApi>(apiInstance, {
  listAll: (limit = PLAYLIST_LIMIT, offset = 0) => ({
    method: 'get',
    url: toQuery('/jsonapi/node/playlist', {
      ...basicPlaylistQuery,
      page: {
        limit,
        offset
      }
    }),
    transform: (result) => result.data.map((playlist) => formatPlaylistBasic(playlist, result.included))
  }),

  getById: (playlistId) => ({
    method: 'get',
    url: toQuery(`/jsonapi/node/playlist/${playlistId}`, playlistQuery),
    transform: (result) => formatPlaylist(result.data, result.included)
  }),

});